// extracted by mini-css-extract-plugin
export var updates = "updateslist-module--updates--2KHw1";
export var inner = "updateslist-module--inner--1QZ3A";
export var list = "updateslist-module--list--1KwM8";
export var date = "updateslist-module--date--103a4";
export var updates_list_item = "updateslist-module--updates_list_item--170FI";